// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"f7bf9352","381":"92d0e323","514":"55e3fa25","671":"2e89e987","787":"41030491","884":"8925e2c8"}[chunkId] + ".chunk.js";
};